function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _ from 'lodash';
import moment from 'moment';
import * as ajax from './ajax';
import store from '../reducers/storeRegistration';
import entityActionFactory from './factories/entityActionFactory';
import mapConstants from '../constants/mapConstants';
import tokenErrorActions from './tokenErrorActionCreators';
const entityActions = entityActionFactory('map', 'forms');
const setCurrentCabinet = currentCabinet => ({
  type: mapConstants.SET_CURRENT,
  currentCabinet
});
const setMapInitialized = cabinetIdentifier => ({
  type: mapConstants.SET_INITIALIZED,
  cabinetIdentifier
});
const serverIndex = (cabinet, indexQuery) => async dispatch => {
  let mapIndexQuery = null;
  const mapStore = store.getState().map;
  if (mapStore.currentCabinet !== cabinet) {
    dispatch(setCurrentCabinet(cabinet));
  }
  if (mapStore[cabinet]) {
    mapIndexQuery = mapStore[cabinet].indexQuery;
  }
  if (indexQuery.initialized && _.isEqual(indexQuery, mapIndexQuery) && moment().isBefore(moment.unix(indexQuery.expiration), 'minute')) {
    return null;
  }
  await dispatch(entityActions.serverIndex(indexQuery));
  return null;
};

/**
 * Set the map type (standard, satellite, or hybrid).
 */
const setMapType = selectedMapType => ({
  type: mapConstants.SET_TYPE,
  payload: selectedMapType
});
const setMapView = (cabinetIdentifier, bbox, zoom) => ({
  type: mapConstants.SET_VIEW,
  payload: {
    cabinetIdentifier,
    bbox,
    zoom
  }
});
const getClusterItems = params => async dispatch => {
  try {
    dispatch({
      type: mapConstants.CLUSTER_ITEMS_REQUEST
    });
    const {
      bbox,
      clusterId,
      filters,
      itemId,
      mapView = true,
      zoom
    } = params;
    let url = `/forms?bbox=${bbox}&zoom=${zoom}&mapView=${mapView}`;
    if (clusterId) {
      url += `&clusterId=${clusterId}`;
    }
    if (itemId) {
      url += `&itemId=${itemId}`;
    }
    Object.entries(filters).forEach(([key, value]) => {
      if (key === 'cabinetIdentifier') {
        url += `&filters[${key}]=${encodeURIComponent(value)}`;
      } else if (Array.isArray(value)) {
        if (value.length > 0 && Array.isArray(value[0])) {
          value.forEach((outer, i) => {
            outer.forEach((inner, j) => {
              url += `&filters[${key}][${i}][${j}]=${encodeURIComponent(inner)}`;
            });
          });
        } else {
          value.forEach(val => {
            url += `&filters[${key}][]=${encodeURIComponent(val)}`;
          });
        }
      }
    });
    const response = await ajax.get(url);
    return dispatch({
      type: mapConstants.CLUSTER_ITEMS_SUCCESS,
      payload: response.data
    });
  } catch (err) {
    return dispatch(tokenErrorActions.handleError(err, 'form', () => ({
      type: mapConstants.CLUSTER_ITEMS_FAILURE,
      error: err
    }), getClusterItems.bind(null, params)));
  }
};
const mapActions = _objectSpread(_objectSpread({}, entityActions), {}, {
  serverIndex,
  getClusterItems,
  setMapInitialized,
  setMapType,
  setMapView,
  setCurrentCabinet
});
export default mapActions;